import { lerp } from "../lib/util";
export class Camera {
    constructor() {
    }
    update(dt) { }
    applyTransform(context) { }
}
export class FocusCamera extends Camera {
    constructor() {
        super();
    }
    update(dt) {
        if (!this.target) {
            return;
        }
        const targetPos = this.target();
        if (!this.curPos) {
            this.curPos = targetPos;
            return;
        }
        const updateSmoothness = 1 - Math.exp(-2 * dt);
        this.curPos.x = lerp(this.curPos.x, targetPos.x, updateSmoothness);
        this.curPos.y = lerp(this.curPos.y, targetPos.y, updateSmoothness);
    }
    applyTransform(context, scale = 1) {
        if (this.curPos) {
            context.translate(Math.round(-scale * this.curPos.x), Math.round(-scale * this.curPos.y));
        }
    }
}
const screenPos = { x: 0.5, y: 0.6 };
export function centerCanvas(context) {
    context.translate(Math.round(context.canvas.width * screenPos.x), Math.round(context.canvas.height * screenPos.y));
}
